import React from 'react';
import './Dropdown.scss';
import classNames from 'classnames';
import Button from '../Button/Button.js';
import SearchableDropdown from '../SearchableDropdown/SearchableDropdown.js';

const Dropdown = ({ value, handleChange, label, handleClick, options, isLoading }) => {
  const isDisabled = value === '';

  return (
    <div className={classNames('tmx-dropdown')}>
      <div className="tmx-dropdown__dropdownContainer">
        {/* <select
          value={value}
          onChange={handleChange}
          defaultValue=""
          className="tmx-dropdown__dropdown"
        >
          <option value="" disabled>
            Join your team
          </option>
          {options &&
            options.length > 0 &&
            options.map((option, i) => (
              <option key={i} value={option.id}>
                {option.name}
              </option>
            ))}
        </select> */}

        <SearchableDropdown
          options={options}
          handleChange={handleChange}
          selectedVal={value}
          label={'Join your team'}
        />
      </div>
      <Button
        handleClick={handleClick}
        label={label}
        isDisabled={isDisabled}
        isLoading={isLoading}
      />
    </div>
  );
};

export default Dropdown;
